var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaYello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2439 1H4.41463C2.52878 1 1 2.52878 1 4.41463V11.2439C1 13.1298 2.52878 14.6585 4.41463 14.6585H11.2439C13.1298 14.6585 14.6585 13.1298 14.6585 11.2439V4.41463C14.6585 2.52878 13.1298 1 11.2439 1Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5608 7.39913C10.6451 7.96749 10.548 8.54796 10.2834 9.05797C10.0188 9.56798 9.60005 9.98156 9.08681 10.2399C8.57358 10.4982 7.99196 10.5881 7.42468 10.4968C6.8574 10.4056 6.33334 10.1377 5.92705 9.73143C5.52077 9.32515 5.25293 8.80109 5.16165 8.23381C5.07037 7.66653 5.16028 7.08491 5.41861 6.57168C5.67693 6.05844 6.09051 5.63973 6.60052 5.3751C7.11053 5.11047 7.691 5.01338 8.25936 5.09767C8.83911 5.18364 9.37584 5.45379 9.79027 5.86822C10.2047 6.28265 10.4749 6.81938 10.5608 7.39913Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaYello);
export default __webpack_public_path__ + "static/media/instaYello.cd817ca4a6d3256c4343528fef967499.svg";
export { ForwardRef as ReactComponent };